import React, {Fragment, useEffect, useState} from 'react'
import { useDispatch } from 'react-redux';
import Button from "src/components/Common/Buttons/Button";
import CamvioTable2 from "src/components/UI/CamvioTable2";
import {createPaymentMethodForm, getMyPaymentMethods} from "src/actions/accountDetailsActions/payNow.actions";
import Loader from "src/components/Loader";



const PaymentMethods = ({accountInfo}) => {
    const dispatch = useDispatch()
    const [paymentMethods, setPaymentMethods] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [tokenValue, setTokenValue] = useState('')

    useEffect(() => {
        fetchPaymentMethods()
    }, []);

  const managePaymentMethods = () => {
    let blurEventFired = false;
    //we need a payment amount attribute to authenticate, payload is not actually used.
    let data = {
      paymentAmount:0,
      submitType: 'managePaymentMethods',
      paymentOption: 'ALL_UNPAID_INVOICES',
      accountInfo: accountInfo
    }
    window.addEventListener('blur', function() {
      blurEventFired = true;
    });

    dispatch(createPaymentMethodForm(accountInfo.id, data)).then((response) => {
      let managePaymentMethodForm = document.getElementById('managePaymentMethodForm');
      managePaymentMethodForm.action = response.data.action
      managePaymentMethodForm.target = response.data.target
      {Object.keys(response.data.fields).map((key) => {
        if (key === 'Token') {
          setTokenValue(response.data.fields[key])
        }
      })}
      managePaymentMethodForm.submit()

      setTimeout(function() {
        if (!blurEventFired) {
          alert('Your browser has a pop-up blocker enabled. Please disable via settings to Manage payment methods.');
        }
      }, 1000);
    })
  }

    const fetchPaymentMethods = () => {
        setIsLoading(true)
        dispatch(getMyPaymentMethods(accountInfo.id))
            .then((response) => {
                setPaymentMethods(response)
                setIsLoading(false)
            });
    }


    const paymentMethodTypeFormatter = (type) => {
        switch(type) {
            case 'CREDIT_CARD':
                return <i className="fas fa-credit-card" title='Credit Card' />;
            case 'ACH':
                return <i className="fas fa-money-check" title='ACH' />;
            case 'WIRE_TRANSFER':
                return <i style={{color: '#8bc34a'}} className="fas fa-dollar-sign" title='Wire Transfer' />;
            case 'EXTERNAL':
                return <i className="fas fa-external-link-square-alt" title='External' />;
            case 'ACCOUNT_CREDIT':
                return <i style={{color: '#f48fb1'}} className="fas fa-piggy-bank" title='Account Credit' />;
            default:
                return <i className="fas fa-question" title='Unknown' />;
        }
    }



    return (
        <Fragment>
                    <div
                        style={{
                            display:'flex',
                            gap:'0.5rem',
                            marginTop: '0.5rem',
                            paddingTop: '0.5rem',
                            justifyContent:'flex-end'
                        }}
                    >
                        <Button
                            className='btn btn-primary btn-cn-add'
                            type="button"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                height: 'fit-content',
                            }}
                            onClick={() => fetchPaymentMethods()}
                        >
                            {isLoading ? "Refreshing..." : "Refresh"}
                        </Button>
                        <Button
                            className='btn btn-primary btn-cn-add'
                            type="button"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                height: 'fit-content',
                                justifyContent: 'flex-end'
                            }}
                            onClick={() => managePaymentMethods()}
                        >
                            Manage
                        </Button>
                        <form id="managePaymentMethodForm" method="post" action="" target="" style={{display: 'none'}}>
                            <input
                                name='Token'
                                placeholder='Token'
                                value={tokenValue}
                                style={{display: 'none'}}
                            />
                        </form>
                    </div>
            {isLoading ?
            <Loader/>
                :
                <CamvioTable2
                headerDefs={[
            {name: "Type", field: "type", sortable: false},
            {name: "Details", field: "displayCardNumber", sortable: false},
                ]}
                style={'striped'}
                >
                <tbody className='cmv-table '>
            {paymentMethods && paymentMethods.length ? paymentMethods.map((method, index) => (
                <tr key={`item_${method.id}`}>
                    <td style={{verticalAlign:'middle'}}>
                        <span>{paymentMethodTypeFormatter(method.type)}</span>
                    </td>
                    <td style={{verticalAlign:'middle', display:'flex', justifyContent:'center'}}>
                        <span>
                        {method.paymentInformation}
                        </span>
                    </td>
                </tr>
                ))
                :
                <tr>
                    <td style={{textAlign:'center'}} colSpan={2}>
                        No data found
                    </td>
                </tr>
            }
                </tbody>
                </CamvioTable2>
            }
        </Fragment>
    )
}
export default PaymentMethods
